import { ADMIN_JOB_TITLES } from 'constants';

type UserLike = { role?: string; job_title?: string };

// Manager and base Admin (no job_title) get full access.
// Lister and Salesman get view + send only.
// Admin Seller gets nothing.
export const canViewRos = (user: UserLike): boolean =>
  user?.role === 'admin' && user?.job_title !== ADMIN_JOB_TITLES.ADMIN_SELLER;

export const canEditRos = (user: UserLike): boolean =>
  user?.role === 'admin' &&
  (!user?.job_title ||
    user?.job_title === ADMIN_JOB_TITLES.ADMIN ||
    user?.job_title === ADMIN_JOB_TITLES.MANAGER);

export const canSendRos = (user: UserLike): boolean =>
  user?.role === 'admin' && user?.job_title !== ADMIN_JOB_TITLES.ADMIN_SELLER;
